import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getBDNotes(params) {
  return request({
    url: '/GetBDNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 401,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keyword
      }
    }
  })
}

export function addBDNotes(params) {
  return request({
    url: '/AddBDNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 402,
      MessageID: btcguid(),
      Data: {
        CompanyName: params.CompanyName,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactContentKeyPoint: params.ContactContentKeyPoint,
        ContactDate: params.ContactDate
      }
    }
  })
}

export function updateBDNotes(params) {
  return request({
    url: '/UpdateBDNotes',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 403,
      MessageID: btcguid(),
      Data: {
        BDNoteID: params.BDNoteID,
        CompanyName: params.CompanyName,
        ContactPerson: params.ContactPerson,
        ContactWay: params.ContactWay,
        ContactContent: params.ContactContent,
        ContactContentKeyPoint: params.ContactContentKeyPoint,
        ContactDate: params.ContactDate
      }
    }
  })
}

export function getBDNoteComments(params) {
  return request({
    url: '/GetBDNoteComments',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 404,
      MessageID: btcguid(),
      Data: {
        BDNoteID: params.BDNoteID,
        PageNum: params.PageNum,
        PageSize: params.PageSize
      }
    }
  })
}

export function addBDNoteComment(params) {
  return request({
    url: '/AddBDNoteComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 405,
      MessageID: btcguid(),
      Data: {
        BDNoteID: params.BDNoteID,
        UserName: params.UserName,
        Comment: params.Comment
      }
    }
  })
}

export function updateBDNoteComment(params) {
  return request({
    url: '/UpdateBDNoteComment',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 406,
      MessageID: btcguid(),
      Data: {
        BDNoteCommentID: params.BDNoteCommentID,
        Comment: params.Comment
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/bdnote.js